import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ExtraBalanceError from '../ExtraBalanceError/ExtraBalanceError';
import ExtraBalanceVerifying from '../ExtraBalanceVerifying/ExtraBalanceVerifying';
import ExtraBalanceService from '../../../services/ExtraBalance';
import ExtraBalanceVerified from '../ExtraBalanceVerified/ExtraBalanceVerified';
import ExtraBalanceCompleted from '../ExtraBalanceCompleted/ExtraBalanceCompleted';

const ExtraBalanceManager = ({ closePanel, setPanelOverlay, reloadTacometry }) => {
  const [verified, setVerified] = useState('');
  const [loading, setLoading] = useState(false);
  const [errorService, setErrorService] = useState(false);
  const [offer, setOffer] = useState(null);
  const [markError, setMarkError] = useState({});


  const [conditions, setConditions] = useState({
    hasDebt: false,
    hasRecharged: false,
    categories: [],
  });

  const isBoolean = bool => typeof bool === 'boolean';

  const timer = [];
  const validate = async () => {
    setVerified('');
    setLoading(true);
    setErrorService(false);
    ExtraBalanceService.getData()
      .then(res => {
        const balanceData = res[0].balance;
        const { hasRecharged, hasDebt } = balanceData;

        setConditions(balanceData);

        if (isBoolean(hasRecharged) && isBoolean(hasDebt)) {
          timer[0] = setTimeout(() => {
            setVerified(hasRecharged && !hasDebt ? 'verified' : 'denied');
          }, 1000);
        }
      })
      .catch(() => {
        setErrorService(true);
        setVerified('denied');
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    validate();
    return () => timer.forEach(time => clearTimeout(time));
  }, []);

  useEffect(() => {
    if (offer) setVerified('completed');
  }, [offer]);

  useEffect(() => {
    if (verified === 'denied') {
      const { hasDebt, hasRecharged } = conditions;
      let markErrorData = {};

      if (errorService) {
        markErrorData = {
          event: 'pagina-virtual',
          page: '/extrasaldo/error-servicio',
          pagename: 'Extrasaldo - Error Servicio',
        };
      } else if (hasDebt && !hasRecharged) {
        markErrorData = {
          event: 'pagina-virtual',
          page: '/extrasaldo/error-deuda-recarga',
          pagename: 'Extrasaldo - Error Deuda y Recarga',
        };
      } else if (!hasDebt && !hasRecharged) {
        markErrorData = {
          event: 'pagina-virtual',
          page: '/extrasaldo/error-recarga',
          pagename: 'Extrasaldo - Error Recarga',
        };
      } else if (hasDebt && hasRecharged) {
        markErrorData = {
          event: 'pagina-virtual',
          page: '/extrasaldo/error-extrasaldo',
          pagename: 'Extrasaldo - Error deuda extrasaldo',
        };
      }

      setMarkError(markErrorData);
    }
  }, [verified]);

  return (
    <>
      {!verified && (
        <ExtraBalanceVerifying conditions={conditions} loading={loading} />
      )}
      {verified === 'verified' && (
        <ExtraBalanceVerified
          categories={conditions.categories}
          setOffer={setOffer}
          closePanel={closePanel}
        />
      )}
      {offer && verified === 'completed' && (
        <ExtraBalanceCompleted offer={offer} closePanel={closePanel} reloadTacometry={reloadTacometry} />
      )}
      {(verified === 'denied' || errorService) && (
        <ExtraBalanceError
          conditions={conditions}
          serviceError={errorService}
          retry={validate}
          closePanel={closePanel}
          markOptions={markError}
          setPanelOverlay={setPanelOverlay}
        />
      )}
    </>
  );
};

ExtraBalanceManager.propTypes = {
  closePanel: PropTypes.func.isRequired,
  reloadTacometry: PropTypes.func.isRequired
};

export default ExtraBalanceManager;
